document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.card-more');

  const delay = 600;
  let canClick = true;

  document.addEventListener('click', event => {
    if (window.innerWidth <= 960) return;
    if (!canClick) return;

    const clickedCard = event.target.closest('.card-more');

    if (!clickedCard) {
      cards.forEach(card => card.classList.remove('is-open'));
      return;
    }

    cards.forEach(card => {
      if (card !== clickedCard) {
        card.classList.remove('is-open');
      }
    });

    clickedCard.classList.toggle('is-open');

    canClick = false;
    setTimeout(() => {
      canClick = true;
    }, delay);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth <= 960) {
      cards.forEach(card => card.classList.remove('is-open'));
    }
  });
});
